import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { team } from "../data/team";

const Team = () => {
  return (
    <div data-testid="team-page">
      {/* Hero */}
      <section className="max-w-7xl mx-auto container-px pt-16 pb-10 md:pt-24">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.22em] text-primary font-semibold">Meet the team</p>
          <h1 className="mt-4 font-heading text-5xl sm:text-6xl lg:text-7xl font-medium tracking-tight leading-[1.02]">
            Warm hands. <span className="wave-underline">Warm hearts</span>.
          </h1>
          <p className="mt-6 text-lg text-foreground/70 max-w-2xl leading-relaxed">
            A small crew but big on kindness, curiosity and empowerment.
          </p>
        </div>
      </section>

      {/* Feature photo */}
      <section className="max-w-6xl mx-auto container-px pt-6 md:pt-8">
        <div className="relative overflow-hidden rounded-[2rem] ring-1 ring-black/5 shadow-lg bg-secondary">
          <img
            src="https://customer-assets.emergentagent.com/job_peerwave-landing/artifacts/g9euuxf1_cassie%20flower.jpg"
            alt="A PeerWave participant celebrating by the sea, arms raised amongst bright poppies"
            className="w-full h-auto block"
            loading="lazy"
          />
        </div>
        <p className="mt-10 max-w-3xl mx-auto text-center text-lg text-foreground/75 leading-relaxed">
          We're a tight-knit crew on the Fraser Coast of supporters, artists
          and organisers who put people at the centre of everything we do.
          When you join PeerWave, you get to know us by name.
          <br />
          We're excited to get to know you for who you truly are.
        </p>
      </section>

      {/* Team grid */}
      <section className="max-w-7xl mx-auto container-px pt-20 md:pt-28 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {team.map((m) => (
            <article
              key={m.name}
              data-testid={`team-card-${m.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="rounded-3xl bg-card border border-border/70 p-8 hover:border-primary/40 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="mx-auto h-32 w-32 rounded-full overflow-hidden ring-4 ring-secondary bg-primary/10">
                {m.image ? (
                  <img
                    src={m.image}
                    alt={m.name}
                    className="h-full w-full object-cover"
                    style={{ objectPosition: "50% 30%" }}
                  />
                ) : (
                  <div className="h-full w-full flex items-center justify-center font-heading text-3xl font-semibold text-primary">
                    {m.initials ||
                      m.name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")
                        .slice(0, 2)}
                  </div>
                )}
              </div>
              <div className="mt-5 text-center">
                <h3 className="font-heading text-xl font-medium">{m.name}</h3>
                <p className="mt-1 text-xs uppercase tracking-[0.2em] text-primary font-semibold">
                  {m.role}
                </p>
              </div>
              <p className="mt-5 text-sm text-foreground/70 leading-relaxed text-center">
                {m.bio}
              </p>
            </article>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-7xl mx-auto container-px pb-24">
        <div className="mt-8 flex justify-center">
          <Button
            asChild
            data-testid="team-cta-contact"
            className="rounded-full bg-primary text-primary-foreground h-14 px-8 hover:-translate-y-0.5 transition-transform"
          >
            <Link to="/contact">
              Say hello
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Team;
